// extracted by mini-css-extract-plugin
export default {"main__container":"layout_main__container__eVOlZ","layout":"layout_layout__emTve","footer":"layout_footer__UaLUY"};